import Sizes from '../definitions/Sizes';


export default {
    FILL: '100%',
    ...Sizes.ICONS,
};
